import React from 'react'
import Footer from './Footer'
import Header from './Header'

function Portfolio() {
  document.title="HR Portfolio"
  return (
    <div>
        <div>
 <Header/>
  {/* custom menu */}
  {/* portfolio section */}
  <section className="portfolio_section layout_padding">
    <div className="container">
      <div className="custom_heading-container">
        <h2>
          Our Portfolio
        </h2>
      </div>
    </div>
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-6">
          <div className="row">
            <div className="col-sm-6">
              <div className="box b-1">
                <img src="images/p-1.png" alt />
                <h4>
                  Logo Designer
                </h4>
              </div>
              <div className="box b-2">
                <img src="images/p-2.png" alt />
                <h4>
                  Coder
                </h4>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="box b-3">
                <img src="images/p-3.png" alt />
                <h4>
                  Bike Racer
                </h4>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="row">
            <div className="col-sm-6">
              <div className="box b-4">
                <img src="images/p-4.png" alt />
                <h4>
                  Digital Marketing Specialist
                </h4>
              </div>
              <div className="box b-5">
                <img src="images/p-5.png" alt />
                <h4>
                  Website Designer
                </h4>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="box b-6">
                <img src="images/p-6.jpeg" alt />
                <h4>
                  Hero Gaur
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  {/* end portfolio section */}
  {/* info section */}
  <Footer/>
  {/* end info_section */}
  {/* footer section */}
  
</div>

    </div>
  )
}

export default Portfolio